export default "<app-page-with-accordion \n[items]=\"customer\" \ntitle='CUSTOMER ACCEPTANCE POLICY'\n>\n</app-page-with-accordion>\n"